import { getAccessRequisitionsEntries } from '../../api'
import { useLazyRequest } from '../useRequest'

export default function useAccessRequisition() {
  const [requestData, { data, loading }] = useLazyRequest(getAccessRequisitionsEntries, { loading: true })

  return { loading, data, requestData }
}
